import NutritionalMenuCalculatorManagement from '@/modules/health-consulting-management/nutritional-menu-calculator-management';

export default function NutritionalMenuCalculatorSlider() {
  const renderContent = () => {
    return <NutritionalMenuCalculatorManagement />;

  };
  return <>{renderContent()}</>;
}
